import { useState, useEffect } from 'react';
import { SelectPicker, Loader } from 'rsuite';

import firebaseService from '../../services/firebase.service';
import axios from 'axios';

import { compare } from '../../utils/helper.utils';

export default function HubspotListPicker(props) {
	const { list, setList, name, onChange, defaultValue } = props;
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const getData = async () => {
		setIsLoading(true);
		const token = await firebaseService.auth.currentUser.getIdToken(true);
		const resp = await axios.get(
			`${process.env.REACT_APP_SERVER}/api/hubspot_lists`,
			{
				headers: {
					authorization: `Bearer ${token}`
				}
			}
		);

		setData(
			resp.data.map((list) => {
				return {
					label: `${list.name} (${list.size.toLocaleString()})`,
					value: list.listId
				};
			})
		);

		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			{isLoading ? (
				<Loader backdrop />
			) : (
				<SelectPicker
					name={name}
					data={data}
					default={list}
					onChange={onChange}
					defaultValue={defaultValue}
					placeholder="Select Hubspot Recipient List"
					sort={() => {
						return (a, b) => {
							return compare(a.label, b.label);
						};
					}}
				/>
			)}
		</div>
	);
}
